<!--
 * @Author: dee
 * @Date: 2022-04-20 11:44:46
 * @LastEditors: dee
 * @LastEditTime: 2022-04-21 09:45:50
 * @Description: file content
-->
<template>
  <div class="bg">
    <BaseImg :option="{
      style: {
        margin: '12px 0 0 16px',
        alignSelf: 'flex-start',
        width: '89px',
      },
      url: 'logo.png',
    }"/>
    <div class="team-box">
      <div class="team-list" v-if="orderList.length > 0">
        <div class="team-item" v-for="(item, index) in orderList" :key="index">
          <div class="left">
            <div class="avatar">
              <img :src="`${item.headImg}`" alt="">
            </div>
            <div class="nickName">{{item.nickName}}</div>
          </div>
          <div class="right">
            <div>还差<span>{{item.needCount}}</span>人</div>
            <div class="join-btn" @click="participateGroup(item)">参与拼团</div>
          </div>
        </div>
      </div>
      <div class="noData" v-else>暂无拼团信息</div>
    </div>
    <div class="btns">
      <div class="my_btn" @click="startGroup">立即拼团</div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
  name: "",
  components: {},
  data() {
    return {
      orderList: [],
      hasProgress: false
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
    this.getOrderList();
    this.getMyProgress();
    // this.$modal.drawForm.alert(
    //   {
    //     drawTxt: 1,
    //     btnTxt: '去领取',
    //     isGroup: true
    //   }
    // )
    // this.$modal.drawForm.alert(
    //   {
    //     drawTxt: 5,
    //     btnTxt: '去分享',
    //     isGroup: true
    //   }
    // )
  },
  methods: {
    async getOrderList() {
      const data = await this.$httpdf.get(this.apiHost + 'groupBuy/orderList')
      if(data.code == 0) {
        this.orderList = data.data
      } else {
        MessageBox.alert(data.msg);
      }
    },
    async getMyProgress() {
      const data = await this.$httpdf.get(this.apiHost + 'groupBuy/myProgress')
      if(data.data) {
        this.hasProgress = true
        if (data.data.finishCount === data.data.joinCount) {
          this.$modal.drawForm.alert(
            {
              drawTxt: 1,
              btnTxt: '去领取',
              isGroup: true,
              groupData: data.data
            }
          ).then((res)=> {
            if (res === 'myprize') {
              this.$goPage('myprize')
            }
          })
        } else {
          this.$modal.drawForm.alert(
            {
              drawTxt: 5,
              btnTxt: '去分享',
              isGroup: true,
              groupData: data.data
            }
          )
        }
      }
    },
    // 开启拼团
    startGroup() {
      if (this.hasProgress) {
        this.getMyProgress()
      } else {
        let prizeId = this.$route.query.prizeId
        this.$modal.drawForm.alert({ prizeId, team: true, groupId: ''});
      }
    },
    // 参与拼团
    participateGroup(v) {
      if (this.hasProgress) {
        this.getMyProgress()
      } else {
        let prizeId = this.$route.query.prizeId
        this.$modal.drawForm.alert({ prizeId, team: true, groupId: v.id});
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.bg {
  padding-bottom: 28px;
  background: url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #FAE5C7 0%, #F6C574 100%);
  .team-box {
    margin: 247px auto 0;
    position: relative;
    z-index: 2;
    padding: 80px 15px 25px;
    width: 343px;
    height: 326px;
    background: url( $imgHost + 'team_box.png?' + $OSSVersion) 0 0 / 100% no-repeat;
    .team-list {
      height: 100%;
      overflow-y: auto;
      padding: 0 12px;
      .team-item {
        position: relative;
        width: 100%;
        padding: 15px 0;
        @extend .flex-center-center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          .avatar {
            width: 37px;
            height: 37px;
            border-radius: 50%;
            img {
              border-radius: 50%;
            }
          }
          .nickName {
            margin-left: 10px;
            max-width: 150px;
            white-space: nowrap;
            overflow-x: hidden;
            text-overflow: ellipsis;
            font-size: 15px;
            font-family: PingFang;
            font-weight: 500;
            color: #333333;
          }
        }
        
        .right {
          font-size: 12px;
          font-family: PingFang;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          display: flex;
          flex-flow: column nowrap;
          text-align: center;
          span {
            color: #FE6F43;
          }
          .join-btn {
            margin-top: 2px;
            width: 80px;
            height: 27px;
            background: #ED7750;
            box-shadow: 0px 1px 3px 0px rgba(235, 69, 62, 0.45);
            border-radius: 13px;
            font-size: 13px;
            font-family: PingFang;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 19px;
            @extend .flex-center-center;
          }
        }
        &+.team-item::after {
          position: absolute;
          top: 0;
          left: 0;
          content: "";
          width: 100%;
          border-top: 1px solid rgba($color: #DF7C54, $alpha: 0.3);
          transform: scaleY(0.5);
        }
      }
    }
    .noData {
      font-size: 14px;
      color: #333333;
      height: 100%;
      @extend .flex-center-center;
    }
  }
  .btns {
    margin-top: 19px;
    .my_btn {
      width: 260px;
      height: 44px;
      background: linear-gradient(180deg, #ffb842 0%, #ff7012 100%);
      box-shadow: 0px 3px 8px 0px rgba(225, 61, 36, 0.51);
      border-radius: 22px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 19px;
      letter-spacing: 2px;
      text-indent: 2px;
      @extend .flex-center-center;
    }
  }
}
</style>
